import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState, useEffect, useCallback } from "react";
import { Link, useParams, NavLink, useNavigate } from "react-router-dom";
import { Nav } from "react-bootstrap";
import DataTableLayout from "layouts/DatatableLayout";
import DatatableLayoutPagination from "layouts/DatatableLayoutPagination";
import DownloadExcel from "utils/DownloadExcel";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { nanoid } from "nanoid";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { defaultOption } from "constants/ui/options";
import { Visibility } from "@mui/icons-material";
import { Avatar, Stack } from "@mui/material";
import moment from "moment";
import { NumberFormat, NumberFormatFloat, getPrefixName, filterTextAndNum } from "utils/HelperFunction";
import { getAllProductInfo } from "../../redux/handlers/product/getAllProductInfo.handler";
import { partnerData } from "mocks/partnerData";
export function ManageProducts() {
    var navigate = useNavigate();
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useState = _sliced_to_array(useState(1), 2), tabPage = _useState[0], setTabPage = _useState[1];
    var _useState1 = _sliced_to_array(useState(""), 2), filterText = _useState1[0], setFilterText = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), filteredItems = _useState2[0], setFilteredItems = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), tableData = _useState3[0], setTableData = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), excelData = _useState4[0], setExcelData = _useState4[1];
    var _useState5 = _sliced_to_array(useState(0), 2), statusItem = _useState5[0], setStatusItem = _useState5[1];
    var _useState6 = _sliced_to_array(useState(""), 2), sDate = _useState6[0], setSDate = _useState6[1];
    var _useState7 = _sliced_to_array(useState(1), 2), pageId = _useState7[0], setPageId = _useState7[1];
    var _useState8 = _sliced_to_array(useState(10), 2), pageSize = _useState8[0], setPageSize = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), sortModel = _useState9[0], setSortModel = _useState9[1];
    var _useState10 = _sliced_to_array(useState(false), 2), loading = _useState10[0], setLoading = _useState10[1];
    var _useState11 = _sliced_to_array(useState(0), 2), totalPage = _useState11[0], setTotalPage = _useState11[1];
    var _useState12 = _sliced_to_array(useState(0), 2), totalAmount = _useState12[0], setTotalAmount = _useState12[1];
    var _useState13 = _sliced_to_array(useState(""), 2), sDateApprove = _useState13[0], setsDateApprove = _useState13[1];
    var _useState14 = _sliced_to_array(useState(""), 2), eDateApprove = _useState14[0], seteDateApprove = _useState14[1];
    // const gettableData = () => {
    //   const payload = {
    //     sDate: sDate ? moment(sDate).format("YYYY-MM-DD") : "",
    //   };
    //   dispatch(getAllProductInfo({payload, modalObj, setModalObj }));
    // };
    var getAllProductInfoReducer = useAppSelector(function(state) {
        return state.getAllProductInfoReducer;
    });
    useEffect(function() {
        var data = _object_spread({
            pageId: pageId,
            pageSize: pageSize
        }, sDate && {
            sDate: moment(sDate).format("YYYY-MM-DD")
        }, sDateApprove && {
            sDateApprove: moment(sDateApprove).format("YYYY-MM-DD")
        }, eDateApprove && {
            eDateApprove: moment(eDateApprove).format("YYYY-MM-DD")
        }, sortModel && {
            sortField: sortModel.sortField,
            sortValue: sortModel.sortValue
        });
        dispatch(getAllProductInfo(data, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    }, [
        pageId,
        pageSize,
        sortModel,
        sDate,
        sDateApprove,
        eDateApprove
    ]);
    // useEffect(() => {
    //   gettableData();
    // }, [sDate]);
    useEffect(function() {
        setIsLoading(getAllProductInfoReducer.isFetching);
        if (getAllProductInfoReducer.data && !getAllProductInfoReducer.isError) {
            var _getAllProductInfoReducer_data_data, _getAllProductInfoReducer_data;
            var data = getAllProductInfoReducer.data.data;
            var pagination = (getAllProductInfoReducer === null || getAllProductInfoReducer === void 0 ? void 0 : (_getAllProductInfoReducer_data = getAllProductInfoReducer.data) === null || _getAllProductInfoReducer_data === void 0 ? void 0 : (_getAllProductInfoReducer_data_data = _getAllProductInfoReducer_data.data) === null || _getAllProductInfoReducer_data_data === void 0 ? void 0 : _getAllProductInfoReducer_data_data.pagination) || {};
            setTableData(data.data);
            setTotalPage((pagination === null || pagination === void 0 ? void 0 : pagination.totalPage) || 0);
            setTotalAmount((pagination === null || pagination === void 0 ? void 0 : pagination.total) || 0);
        }
    }, [
        getAllProductInfoReducer
    ]);
    var columns = [
        {
            id: "presentation_code",
            name: "รหัสลิสต์",
            selector: function(row) {
                return row.pd_ppresentation_code;
            },
            width: "170px",
            center: "true",
            sortable: true,
            sortField: "pd_ppresentation_code",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_products/datalist/" + row.pd_ppresentation_id,
                        children: row.pd_ppresentation_code ? row.pd_ppresentation_code : "ไม่มีรหัส"
                    })
                });
            }
        },
        {
            id: "business_name",
            name: "ชื่อธุรกิจ",
            selector: function(row) {
                return row.pd_ppresentation_businessid;
            },
            sortable: true,
            sortField: "pd_ppresentation_businessid",
            width: "200px",
            cell: function(row, index, column, id) {
                return row.BusBusiness && row.BusBusiness.bus_business_businesstype && row.BusBusiness.bus_business_businesstype == 2 ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.BusBusiness.bus_business_name && row.BusBusiness.bus_business_name != "" && row.BusBusiness.bus_business_name != null ? (filterTextAndNum(row.BusBusiness.bus_business_comprefixname) + row.BusBusiness.bus_business_name + filterTextAndNum(row.BusBusiness.bus_business_suffixname)).trim() : "-"
                }) : row.BusBusiness && row.BusBusiness.bus_business_businesstype && row.BusBusiness.bus_business_businesstype == 1 ? /*#__PURE__*/ _jsx(_Fragment, {
                    children: row.BusBusiness.bus_business_fname && row.BusBusiness.bus_business_fname != "" && row.BusBusiness.bus_business_fname != null ? getPrefixName(row.BusBusiness.bus_business_prefixid) + row.BusBusiness.bus_business_fname + " " + row.BusBusiness.bus_business_lname : "-"
                }) : /*#__PURE__*/ _jsx(_Fragment, {
                    children: "-"
                });
            }
        },
        {
            id: "presentation_name",
            name: "ชื่อลิสต์",
            selector: function(row) {
                return row.pd_ppresentation_name && row.pd_ppresentation_name != "" && row.pd_ppresentation_name != null ? row.pd_ppresentation_name : "-";
            },
            width: "200px",
            sortable: true,
            sortField: "pd_ppresentation_name"
        },
        {
            id: "totalproduct",
            name: "จำนวนรายการ",
            selector: function(row) {
                return row.pd_ppresentation_totalproduct ? row.pd_ppresentation_totalproduct : "-";
            },
            center: "true",
            width: "200px",
            sortable: true,
            sortField: "pd_ppresentation_totalproduct"
        },
        {
            id: "sendapprovedate",
            name: "วันที่นำเสนอ",
            selector: function(row) {
                return row.pd_ppresentation_sendapprovedate ? moment(row.pd_ppresentation_sendapprovedate).format("DD/MM/YYYY") : "-";
            },
            center: "true",
            width: "150px",
            sortable: true,
            sortField: "pd_ppresentation_sendapprovedate"
        },
        {
            id: "approvedate",
            name: "วันที่อนุมัติ",
            selector: function(row) {
                return row.pd_ppresentation_approvedate ? moment(row.pd_ppresentation_approvedate).format("DD/MM/YYYY") : "-";
            },
            center: "true",
            width: "150px",
            sortable: true,
            sortField: "pd_ppresentation_approvedate"
        },
        {
            id: "remark",
            name: "หมายเหตุ",
            selector: function(row) {
                return row.pd_ppresentation_remark ? row.pd_ppresentation_remark : "-";
            },
            center: "true",
            sortable: true,
            sortField: "pd_ppresentation_remark"
        },
        {
            id: "status_pp",
            name: "สถานะ",
            selector: function(row) {
                return row.pd_ppresentation_status;
            },
            center: "true",
            width: "150px",
            sortable: true,
            sortField: "pd_ppresentation_status",
            cell: function(row, index, column, id) {
                return row.pd_ppresentation_status == 5 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "#6f42c1",
                        backgroundColor: "#e2d9f3",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "รอแก้ไข"
                }) : row.pd_ppresentation_status == 4 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(211, 47, 47, 1)",
                        backgroundColor: "rgba(253, 237, 237, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "ยกเลิก"
                }) : row.pd_ppresentation_status == 3 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(114, 225, 40, 0.87)",
                        backgroundColor: "rgba(238, 251, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "ตรวจสอบแล้ว"
                }) : row.pd_ppresentation_status == 2 ? /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(253, 180, 40, 1)",
                        backgroundColor: "rgba(255, 246, 229, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "รอตรวจสอบ"
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "px-2 py-1 text-center",
                    style: {
                        color: "rgba(116, 116, 116, 1)",
                        backgroundColor: "rgba(244, 244, 244, 1)",
                        borderRadius: "20px",
                        width: "130px"
                    },
                    children: "แบบร่าง"
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.pd_ppresentation_id;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx(Stack, {
                    direction: "row",
                    spacing: 1,
                    sx: {
                        justifyContent: "center",
                        alignItems: "center"
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/manage_products/datalist/" + row.pd_ppresentation_id,
                        children: row.pd_ppresentation_id ? /*#__PURE__*/ _jsx(Avatar, {
                            sx: {
                                color: "rgba(253, 180, 40, 1)",
                                bgcolor: "rgba(255, 246, 229, 1)"
                            },
                            children: /*#__PURE__*/ _jsx(Visibility, {
                                sx: {
                                    fontSize: 30
                                }
                            })
                        }) : "-"
                    })
                });
            },
            width: "170px",
            center: "true"
        }
    ];
    useEffect(function() {
        if (statusItem && statusItem > 0 && filterText && filterText != "" && filterText != null) {
            setFilteredItems(tableData.filter(function(item) {
                return item.pd_ppresentation_id !== null && item.pd_ppresentation_status == statusItem && (item.pd_ppresentation_code != null && item.pd_ppresentation_code.toUpperCase().includes(filterText.toUpperCase()) || item.pd_ppresentation_name != null && item.pd_ppresentation_name.includes(filterText));
            }));
        } else if (statusItem && statusItem > 0 && (!filterText || filterText == "")) {
            setFilteredItems(tableData.filter(function(item) {
                return item.pd_ppresentation_id !== null && item.pd_ppresentation_status == statusItem;
            }));
        } else if (filterText && filterText != "" && filterText != null && statusItem <= 0) {
            setFilteredItems(tableData.filter(function(item) {
                return item.pd_ppresentation_id !== null && item.pd_ppresentation_status > 1 && (item.pd_ppresentation_code != null && item.pd_ppresentation_code.toUpperCase().includes(filterText.toUpperCase()) || item.pd_ppresentation_name != null && item.pd_ppresentation_name.includes(filterText));
            }));
        } else {
            setFilteredItems(tableData.filter(function(item) {
                return item.pd_ppresentation_id !== null && item.pd_ppresentation_status > 1;
            }));
        }
    }, [
        tableData,
        statusItem,
        filterText
    ]);
    // useEffect(() => {
    //   if(filteredItems && filteredItems.length > 0){
    //     filteredItems.map((item,index) =>
    //     {
    //         if(item.pd_ppresentation_id && item.pd_ppresentation_id != '' && item.pd_ppresentation_id>0) {
    //           setExcelData(excelData => [
    //             ...excelData,
    //             {
    //               present_no : (index + 1),
    //               present_code : item.pd_ppresentation_code,
    //               present_business : (item.BusBusiness && item.BusBusiness.bus_business_businesstype
    //                                   && item.BusBusiness.bus_business_businesstype == 2) ?
    //                                       (item.BusBusiness.bus_business_name && item.BusBusiness.bus_business_name != ''
    //                                         && item.BusBusiness.bus_business_name != null) ?
    //                                           item.BusBusiness.bus_business_name
    //                                       : "-"
    //                                   : (item.BusBusiness && item.BusBusiness.bus_business_businesstype
    //                                     && item.BusBusiness.bus_business_businesstype == 1) ?
    //                                         (item.BusBusiness.bus_business_fname && item.BusBusiness.bus_business_fname != ''
    //                                           && item.BusBusiness.bus_business_fname != null)?
    //                                             item.BusBusiness.bus_business_fname + " " + item.BusBusiness.bus_business_lname
    //                                         : "-"
    //                                   : "-",
    //               present_name : (item.pd_ppresentation_name && item.pd_ppresentation_name != '' && item.pd_ppresentation_name != null) ?
    //                                 item.pd_ppresentation_name
    //                               : "-",
    //               product_amount : (item.pd_ppresentation_totalproduct && item.pd_ppresentation_totalproduct != null
    //                                 && item.pd_ppresentation_totalproduct != '') ? NumberFormat(item.pd_ppresentation_totalproduct,0) : "-",
    //               present_date : (item.pd_ppresentation_sendapprovedate && item.pd_ppresentation_sendapprovedate != null
    //                                 && item.pd_ppresentation_sendapprovedate != '') ? moment(item.pd_ppresentation_sendapprovedate).format("DD/MM/YYYY")
    //                               : "-",
    //               approve_date : (item.pd_ppresentation_approvedate && item.pd_ppresentation_approvedate != null
    //                                 && item.pd_ppresentation_approvedate != '') ? moment(item.pd_ppresentation_approvedate).format("DD/MM/YYYY")
    //                               : "-",
    //               present_remark : (item.pd_ppresentation_remark && item.pd_ppresentation_remark != '' && item.pd_ppresentation_remark != null) ?
    //                                 item.pd_ppresentation_remark
    //                               : "-",
    //               status : (item.pd_ppresentation_status && item.pd_ppresentation_status == 5) ?
    //                           "รอแก้ไข"
    //                         : (item.pd_ppresentation_status && item.pd_ppresentation_status == 4) ?
    //                           "ยกเลิก"
    //                         : (item.pd_ppresentation_status && item.pd_ppresentation_status == 3) ?
    //                           "ตรวจสอบแล้ว"
    //                         : (item.pd_ppresentation_status && item.pd_ppresentation_status == 2) ?
    //                           "รอตรวจสอบ"
    //                         : "แบบร่าง",
    //             }
    //           ]);
    //         }
    //     });
    //   }
    // }, [filteredItems]);
    useEffect(function() {
        if (filteredItems && filteredItems.length > 0) {
            filteredItems.map(function(item, index) {
                if (item.bus_business_id && item.bus_business_id != "" && item.bus_business_id > 0) {
                    setExcelData(function(excelData) {
                        return _to_consumable_array(excelData).concat([
                            {
                                partner_no: index + 1,
                                partner_code: item.mb_mem_code,
                                vendor_code: item.bus_business_vendorcode,
                                approval_date: item.bus_business_credate && item.bus_business_credate != null && item.bus_business_credate != "" ? moment(item.bus_business_credate).format("DD/MM/YYYY") : "-",
                                name_company: item.bus_business_name && item.bus_business_name != null && item.bus_business_name != "" ? item.bus_business_name : "-",
                                tax_numer: item.bus_business_taxid && item.bus_business_taxid != null && item.bus_business_taxid != "" ? item.bus_business_taxid : "-",
                                type_company: item.bus_business_businesstype && item.bus_business_businesstype == 2 ? "นิติบุคคล" : item.bus_business_businesstype && item.bus_business_businesstype == 1 ? "บุคคลธรรมดา" : "-",
                                product_amount: 0,
                                status_bank: item.bus_business_bankstatus && item.bus_business_bankstatus == 3 ? "ตรวจสอบแล้ว" : item.bus_business_bankstatus && item.bus_business_bankstatus == 2 ? "รอตรวจสอบ" : "แบบร่าง",
                                status_document: item.bus_business_docstatus && item.bus_business_docstatus == 3 ? "ตรวจสอบแล้ว" : item.bus_business_docstatus && item.bus_business_docstatus == 2 ? "รอตรวจสอบ" : "แบบร่าง",
                                status: item.bus_business_status && item.bus_business_status == 5 ? "ไม่อนุมัติ" : item.bus_business_status && item.bus_business_status == 4 ? "รอแก้ไข" : item.bus_business_status && item.bus_business_status == 3 ? "อนุมัติ" : item.bus_business_status && item.bus_business_status == 2 ? "รออนุมัติ" : "แบบร่าง"
                            }
                        ]);
                    });
                }
            });
        }
    }, [
        filteredItems
    ]);
    var handleChangePage = function(newPage) {
        setPageId(newPage);
    };
    var handleChangeRowsPerPage = function(newPageSize) {
        setPageSize(newPageSize);
    };
    var handleSort = function(column, sortDirection) {
        var field = column === null || column === void 0 ? void 0 : column.sortField;
        var value = sortDirection; // 'asc' หรือ 'desc'
        console.log("Sort:", {
            sortField: field,
            sortValue: value
        });
        setSortModel({
            sortField: field,
            sortValue: value
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0 mb-1",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "จัดการสินค้านำเสนอ"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "รายละเอียด",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mb-2",
                        children: /*#__PURE__*/ _jsx("h3", {
                            className: "h3",
                            children: "นำเสนอสินค้า"
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mb-4",
                        children: /*#__PURE__*/ _jsxs(Nav, {
                            variant: "pills",
                            defaultActiveKey: tabPage,
                            onSelect: function(selectedKey) {
                                setTabPage(selectedKey);
                                if (selectedKey == 4) {
                                    setStatusItem(4);
                                } else if (selectedKey == 3) {
                                    setStatusItem(3);
                                } else if (selectedKey == 2) {
                                    setStatusItem(2);
                                } else {
                                    setStatusItem(0);
                                }
                            },
                            className: "mb-3",
                            children: [
                                /*#__PURE__*/ _jsx(Nav.Item, {
                                    children: /*#__PURE__*/ _jsx(Nav.Link, {
                                        className: "tc-13 nav-danger",
                                        eventKey: "1",
                                        children: "ทั้งหมด"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Nav.Item, {
                                    children: /*#__PURE__*/ _jsx(Nav.Link, {
                                        className: "tc-13 nav-danger",
                                        eventKey: "2",
                                        children: "รอตรวจสอบ"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Nav.Item, {
                                    children: /*#__PURE__*/ _jsx(Nav.Link, {
                                        className: "tc-13 nav-danger",
                                        eventKey: "3",
                                        children: "ตรวจสอบแล้ว"
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Nav.Item, {
                                    children: /*#__PURE__*/ _jsx(Nav.Link, {
                                        className: "tc-13 nav-danger",
                                        eventKey: "4",
                                        children: "ยกเลิก"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "card card-st-2",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "card-body pt-4 pb-0",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "row gx-xl-4 mb-2",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-3 col-md-12",
                                        children: /*#__PURE__*/ _jsxs(Stack, {
                                            direction: "row",
                                            justifyContent: "flex-start",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "whitespace-nowrap",
                                                    children: "ค้นหาวันที่นำเสนอ"
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    selected: sDate,
                                                    onChange: function(date) {
                                                        return setSDate(date);
                                                    },
                                                    dateFormat: "dd-MM-yyyy",
                                                    className: "form-control ml-2 px-2",
                                                    placeholderText: "เลือกวันที่",
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-6 col-md-12",
                                        children: /*#__PURE__*/ _jsxs(Stack, {
                                            direction: "row",
                                            justifyContent: "flex-start",
                                            children: [
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: " mb-2 px-2 w-[380px]",
                                                    children: "วันที่รอบการชำระ"
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    selected: sDateApprove,
                                                    onChange: function(date) {
                                                        return setsDateApprove(date);
                                                    },
                                                    dateFormat: "dd-MM-yyyy",
                                                    className: "form-control px-2 mb-2",
                                                    isClearable: true
                                                }),
                                                /*#__PURE__*/ _jsx("div", {
                                                    className: "mb-2 px-2",
                                                    children: "ถึง"
                                                }),
                                                /*#__PURE__*/ _jsx(DatePicker, {
                                                    selected: eDateApprove,
                                                    onChange: function(date) {
                                                        return seteDateApprove(date);
                                                    },
                                                    dateFormat: "dd-MM-yyyy",
                                                    className: "form-control px-2 mb-2",
                                                    isClearable: true
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "col-xl-3 col-md-12",
                                        children: /*#__PURE__*/ _jsx("input", {
                                            type: "text",
                                            className: "form-control w-100",
                                            placeholder: "ค้นหารายการ",
                                            onKeyUp: function(e) {
                                                return setFilterText(e.target.value);
                                            }
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: "d-flex align-items-center mb-3 flex-wrap",
                                children: /*#__PURE__*/ _jsx(DownloadExcel, {
                                    data: excelData,
                                    filename: "present_" + moment().format("YYYYMMDDHHmmss")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "card-body px-0 pb-0",
                        children: /*#__PURE__*/ _jsx(DatatableLayoutPagination, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: false,
                            currentPage: pageId,
                            currentPageSize: pageSize,
                            onChangePage: handleChangePage,
                            onChangePageSize: handleChangeRowsPerPage,
                            totalPage: totalPage,
                            totalAmount: totalAmount,
                            sortModel: sortModel,
                            onChangeSort: setSortModel,
                            handleSort: handleSort,
                            loading: loading
                        })
                    })
                ]
            })
        ]
    });
}
